import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { BaseButton } from 'crm/_components';
import { clearWazzupContactIframe, getWazzupContactIframe } from 'crm/wazzup/_redux';
import { staticStyles } from './style';

const TabWazzup = ({ contactId }) => {
  const dispatch = useDispatch();
  const result = useSelector(state => state.crm.wazzup.contactIframe);

  useEffect(() => {
    dispatch(getWazzupContactIframe.request(contactId));
    return () => dispatch(clearWazzupContactIframe(contactId));
  }, [dispatch, contactId]);

  const current = result?.contactId === contactId ? result : null;
  let message;
  if (!current || current.status === null) {
    message = <FormattedMessage id="justLoading" />;
  } else if ([403, 404].includes(current.status)) {
    message = <FormattedMessage id="wazzupContactUnavailable" />;
  } else if (current.status === 409) {
    message = <FormattedMessage id="wazzupIsNotConnected" />;
  } else if (current.status !== 200) {
    message = <FormattedMessage id="wazzupChatLoadError" />;
  } else if (!current.link) {
    message = <FormattedMessage id="wazzupNoLinkedChats" />;
  }

  return (
    <div className="TabWazzup">
      {current?.link ? (
        <iframe src={current.link} title="Wazzup" allow="microphone *; clipboard-write *" />
      ) : (
        <div className="TabWazzup__status" role="status">
          <p>{message}</p>
          {current && current.status !== null && (
            <BaseButton textId="justRetry" onClick={() => dispatch(getWazzupContactIframe.request(contactId))} />
          )}
        </div>
      )}
      <style jsx>{staticStyles}</style>
    </div>
  );
};

TabWazzup.propTypes = {
  contactId: PropTypes.string.isRequired,
};

export default TabWazzup;
